export const BLOCKED_SHARE_STATES = new Set(["rhpfiled", "drhpfiled", "listed"]);

export const ALLOWED_SHARE_STATES = new Set(["unlisted"]);

export enum ProductVisibility {
    "rhpfiled" = "RHP",
    "drhpfiled" = "DRHP",
    "listed" = "Listed",
}

export enum ProductVisibilityStatus {
    "rhpfiled" = "RHP filed",
    "drhpfiled" = "DRHP filed",
    "listed" = "Listed",
}

type BrowseVisibilityProduct = {
    showOnBrowse?: boolean;
    shareState?: string | null;
};

export const isVisibleOnBrowse = (product?: BrowseVisibilityProduct | null): boolean => {
    if (product?.showOnBrowse !== true) {
        return false;
    }

    const normalizedShareState = product?.shareState?.toLowerCase().trim();

    if (!normalizedShareState) {
        return true;
    }

    return !BLOCKED_SHARE_STATES.has(normalizedShareState);
};
